import React from "react";
import "./App.css";
import FileUpload from "./components/FileUpload";



function App({user}) {

  return (
    <div className="App">
      <header className="App-header">
        <h1>Upload files</h1>
        <FileUpload user={user} />   
      </header>
    </div>
  );
}

export default App;
